import { type Guard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Determines whether adding to the bag was requested before the product was
 * ready.
 */
export const checkIfAddToBagPending: Guard = function (args): boolean {
  return args.context.shouldAddToBagWhenReady;
};
